module.exports = __webpack_public_path__ + "media/warbling-vireo-3.28b757f5.mp3";